import LazyRoute from 'approot/shared/routes/lazy-route';

import {
  PRIVATE_TRIAL,
  PRIVATE_TRIAL_SUPPORT,
} from 'global/private-routes.constants';

const trialRoutes = [
  {
    path: `${PRIVATE_TRIAL}/*`,
    component: LazyRoute(() => import('./trial')),
  },
  {
    path: `${PRIVATE_TRIAL_SUPPORT}/*`,
    component: LazyRoute(() => import('./trial-support')),
  },
];

export default trialRoutes;
